var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"loading":_vm.loading,"to":_vm.isExternalLink ? null : _vm.to,"href":_vm.isExternalLink ? _vm.to : null,"size":_vm.size,"color":_vm.color,"icon":_vm.icon,"target":_vm.target,"border":_vm.border,"tag":_vm.tag}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }